import { ActionTypes } from '../../constants/ActionTypes';
import { IConvertStatus } from '../../interfaces';

const INIT_STATE: IConvertStatus = {
  convertStatus: true,
  letterCode: '',
};

export default (state = INIT_STATE, action: any) => {
  switch (action.type) {
    case ActionTypes.FETCH_CONVERTSTATUS_SUCCESS: {
      return {
        ...state,
        convertStatus: action.payload,
      };
    }

    case ActionTypes.GET_CONVERTSTATUS: {
      return {
        ...state,
        letterCode: action.payload,
        convertStatus: true,
      };
    }

    default:
      return state;
  }
};
